(function() {
  const SELECTOR = '.hero-product-carousel';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class HeroProductCarouselController {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.heroProductCarousel__track');
      this.slides = Array.from(root.querySelectorAll('.heroProductCarousel__slide'));
      this.dots = Array.from(root.querySelectorAll('.heroProductCarousel__dot'));
      this.prevBtn = root.querySelector('.heroProductCarousel__arrow--prev');
      this.nextBtn = root.querySelector('.heroProductCarousel__arrow--next');
      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 4000;
      this.respectReducedMotion = root.dataset.respectReducedMotion === 'true';
      this.currentIndex = 0;
      this.timer = null;
      this.visible = false;

      if (!this.track || this.slides.length < 2) {
        this.setActiveDot(0);
        return;
      }

      this.setup();
    }

    setup() {
      this.onVisibility = this.onVisibility.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onUserInteract = this.onUserInteract.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.observer = new IntersectionObserver(this.onVisibility, {
        root: null,
        threshold: 0.5
      });
      this.observer.observe(this.root);

      window.addEventListener('resize', this.onResize, { passive: true });
      this.track.addEventListener('pointerdown', this.onUserInteract, { passive: true });
      this.track.addEventListener('touchstart', this.onUserInteract, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stop();
        } else if (this.visible) {
          this.start();
        }
      });

      if (this.shouldAutoplay()) {
        this.start();
      }

      this.setActiveDot(0);
    }

    shouldAutoplay() {
      if (!this.autoplayEnabled) return false;
      if (this.respectReducedMotion && prefersReducedMotion()) return false;
      return true;
    }

    onPrev() {
      this.stop();
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.scrollToIndex(prevIndex, true);
      if (this.shouldAutoplay()) this.start();
    }

    onNext() {
      this.stop();
      this.next();
      if (this.shouldAutoplay()) this.start();
    }

    onDotClick(event) {
      const index = parseInt(event.currentTarget.dataset.index, 10);
      if (Number.isInteger(index)) {
        this.stop();
        this.scrollToIndex(index, true);
        if (this.shouldAutoplay()) this.start();
      }
    }

    onVisibility(entries) {
      entries.forEach(entry => {
        this.visible = entry.isIntersecting;
        if (this.visible && this.shouldAutoplay()) {
          this.start();
        } else {
          this.stop();
        }
      });
    }

    onResize() {
      // Keep the current slide centered after resize
      this.scrollToIndex(this.currentIndex, false);
    }

    onUserInteract() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => {
        this.next();
      }, this.autoplayMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.scrollToIndex(nextIndex, true);
    }

    scrollToIndex(index, smooth = true) {
      const slide = this.slides[index];
      if (!slide) return;
      const offset = slide.offsetLeft;
      this.track.scrollTo({
        left: offset,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.currentIndex = index;
      this.setActiveDot(index);
    }

    setActiveDot(index) {
      if (!this.dots || !this.dots.length) return;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(root => {
      if (!root._heroProductCarousel) {
        root._heroProductCarousel = new HeroProductCarouselController(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
